export const GET_ALL_CARD_TYPE_CONFIGURATIONS =
  "GET_ALL_CARD_TYPE_CONFIGURATIONS";
export const SET_ALL_CARD_TYPE_CONFIGURATIONS =
  "SET_ALL_CARD_TYPE_CONFIGURATIONS";
export const GET_ALL_CARE_PRINCIPAL_ACCESS = "GET_ALL_CARE_PRINCIPAL_ACCESS";
export const SET_ALL_CARE_PRINCIPAL_ACCESS = "SET_ALL_CARE_PRINCIPAL_ACCESS";
// COMFACT - KOMMER ATT TAS BORT 
// export const GET_ALL_ALLOWED_CONTRACTS = "GET_ALL_ALLOWED_CONTRACTS";
// export const SET_ALL_ALLOWED_CONTRACTS = "SET_ALL_ALLOWED_CONTRACTS";
export const GET_ALL_JOBS_CONFIGURATIONS = "GET_ALL_JOBS_CONFIGURATIONS";
export const SET_ALL_JOBS_CONFIGURATIONS = "SET_ALL_JOBS_CONFIGURATIONS";

export const getAllCardTypeConfigurations = () => ({
  type: GET_ALL_CARD_TYPE_CONFIGURATIONS,
});

export const setAllCardTypeConfigurations = (allcardTypeConfigs: any) => ({
  type: SET_ALL_CARD_TYPE_CONFIGURATIONS,
  allcardTypeConfigs,
});

export const setAllCarePrincipalAccess = (allCarePrincipalAccess: any) => ({
  type: SET_ALL_CARE_PRINCIPAL_ACCESS,
  allCarePrincipalAccess,
});

// COMFACT - KOMMER ATT TAS BORT 
// export const setAllAllowedContracts = (allAllowedContracts: any) => ({
//   type: SET_ALL_ALLOWED_CONTRACTS,
//   allAllowedContracts,
// });

export const setAllJobsConfigurations = (allJobsConfigurations: any) => ({
  type: SET_ALL_JOBS_CONFIGURATIONS,
  allJobsConfigurations,
});

const initialState = {};

export const infoReducer = (state = initialState, action: any) => {
  const { allcardTypeConfigs } = action;
  const { allCarePrincipalAccess } = action;
  const { allJobsConfigurations } = action;
  // COMFACT - KOMMER ATT TAS BORT 
  // const { allAllowedContracts } = action;

  switch (action.type) {
    case SET_ALL_CARD_TYPE_CONFIGURATIONS:
      return { ...state, allcardTypeConfigs };
    case SET_ALL_CARE_PRINCIPAL_ACCESS:
      return { ...state, allCarePrincipalAccess };
    // COMFACT - KOMMER ATT TAS BORT 
    // case SET_ALL_ALLOWED_CONTRACTS:
    //   return { ...state, allAllowedContracts };
    case SET_ALL_JOBS_CONFIGURATIONS:
      return { ...state, allJobsConfigurations };
    default:
      return state;
  }
};
